import axios from "../config/axios-chatbot";


export const NotificationsRepository = {
  getAllNotifications: ({flowUid, page = 0, size = 5, sortBy = "id", sortDir = "desc", signal}) =>
    axios.get("/api/notifications", {
      params: { flowUid, page, size, sortBy, sortDir },
      signal
    }),
    
  getNotification: ({id}) => axios.get(`/api/notifications/${id}`),
  
  createNotification: ({body}) => axios.post("/api/notifications", {...(body || {})}),
  
  updateNotification: ({id, body}) => axios.put(`/api/notifications/${id}`, {...(body || {})}),
  
  deleteNotification: ({id}) => axios.delete(`/api/notifications/${id}`),
  
  getNotificationsCount: ({flowUid, username, signal}) => axios.get("/api/notifications/count", {params: {flowUid, username}, signal}),
  
  notificationExists: ({id}) => axios.get(`/api/notifications/exists/${id}`),
  
  markNotificationsAsViewed: ({notificationIds, username, flowUid}) =>
    axios.put("/api/notifications/mark-viewed", {
      notificationIds,
      username,
      flowUid
    })
}